import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import type IDealCellData from '@/finsight/ui/components/deals/DealListTable/cells/types';

export const Region = ({ row: deal }: { row: IDealCellData }) => {
  const { region } = deal;
  return (
    <Tooltip content={ `Issuer Domicile: ${ region.name }` }>
      { region.abbreviation }
    </Tooltip>
  );
};
